import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import { FormControlLabel, Checkbox } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import moment from "moment"
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import excelJS from 'exceljs'
import DownloadIcon from '@mui/icons-material/Download';

const BotonReporteExcelComponent = (props) => {

    let clientes = props?.clientes
    let tipoActividades = props?.actividadesSeleccionadas
    const dispatch = useDispatch()


    const filtrarClientesExcel = async () => {
        let aux = []

        if (tipoActividades.length > 0) {
            tipoActividades.map(textoBuscar => {
                let busquedaExcel = []

                busquedaExcel = clientes.filter((cliente) =>
                    cliente.actividadcliente[0]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[1]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[2]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[3]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[4]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase() ||
                    cliente.actividadcliente[5]?.tipoactividad.actividad.toLowerCase() == textoBuscar.toLowerCase()
                );

                aux.push(...busquedaExcel)
            })
        } else {
            aux = clientes
        }

        const clientesMap = aux.map(cliente => {
            return [cliente.idcliente, cliente]
        });

        let clientesFiltroSinRepetidos = [...new Map(clientesMap).values()];

        reporteClientes(clientesFiltroSinRepetidos)
    }

    const reporteClientes = async (clientesFiltroSinRepetidos) => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        await dispatch(actualizarLoadingApp_true())

        let arregloCliente = []
        for (const i in clientesFiltroSinRepetidos) {
            let { ...cliente } = clientesFiltroSinRepetidos?.[i]

            let tipoPersona = ''
            let actividades = []

            if (cliente.personafisica == true) tipoPersona = 'FISICA'
            else if (cliente.personamoral == true) tipoPersona = 'MORAL'

            cliente?.actividadcliente?.map(item =>
                actividades.push(item?.tipoactividad?.actividad)
            )

            let cadenaActividades = obtenerCadenaActividades(actividades)
            let cadenaDomicilios = obtenerDomicilios(cliente?.domiciliofiscalcliente)

            arregloCliente.push({
                numsocio: cliente?.numerosocio,
                nombrecliente: cliente?.nombrerazonsocial?.toUpperCase(),
                tipocliente: cliente?.tipocliente?.tipocliente?.toUpperCase(),
                tipopersona: tipoPersona,
                rfc: cliente?.rfc?.toUpperCase(),
                actividadescliente: cadenaActividades?.toUpperCase(),
                domicilio: cadenaDomicilios,
                telefono: cliente?.telefono,
                correoelectronico: cliente?.correoelectronico?.toLowerCase(),
                nombrerepresentante: cliente?.nombrerepresentantelegal?.toUpperCase(),
                telefonorepresentante: cliente?.telefonorepresentante,
                correorepresentante: cliente?.correoelectronicorepresentante.toLowerCase()
            })
        }

        const workbook = new excelJS.Workbook();
        const worksheet = workbook.addWorksheet("Clientes");

        let abc = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'];

        worksheet.columns = [
            { header: "N° SOCIO", key: "numsocio", width: 15 },
            { header: "NOMBRE O RAZÓN SOCIAL", key: "nombrecliente", width: 40 },
            { header: "TIPO DE CLIENTE", key: "tipocliente", width: 20 },
            { header: "TIPO DE PERSONA", key: "tipopersona", width: 20 },
            { header: "RFC", key: "rfc", width: 20 },
            { header: "ACTIVIDADES CLIENTE", key: "actividadescliente", width: 30 },
            { header: "DOMICILIO", key: "domicilio", width: 50 },
            { header: "TELEFONO", key: "telefono", width: 25 },
            { header: "CORREO ELECTRONICO", key: "correoelectronico", width: 35 },
            { header: "NOMBRE REPRESENTANTE LEGAL", key: "nombrerepresentante", width: 40 },
            { header: "TELÉFONO REPRESENTANTE", key: "telefonorepresentante", width: 25 },
            { header: "CORREO REPRESENTANTE", key: "correorepresentante", width: 35 }
        ];

        abc.slice(0, 12).map(key => {
            worksheet.getCell(key).fill = {
                type: 'pattern',
                pattern: 'solid',
                height: 100,
                fgColor: { argb: '9AC4F8' }
            };
            worksheet.getCell(key).alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });

        arregloCliente.forEach((user) => {
            worksheet.addRow(user);
            const row = worksheet.lastRow;
            row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(2).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(6).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(7).alignment = { vertical: 'middle', wrapText: true };
            row.getCell(8).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(9).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(10).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(11).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(12).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        });

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
        });

        await dispatch(actualizarLoadingApp_false())
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const blob = new Blob([buffer], { type: fileType });
            saveAs(blob, 'ReporteClientes' + fechaHoy.substring(0, 10) + EXCEL_EXTENSION);
        } catch (err) {
            console.log("error ", err)
        }
        await dispatch(actualizarLoadingApp_false())
        setOpenModalReporte(false)
    }

    const obtenerCadenaActividades = (actividadcliente) => {

        let combinacionCadena = '';
        if (actividadcliente.length == 1) {
            combinacionCadena = actividadcliente[0];
        } else if (actividadcliente.length > 1) {
            combinacionCadena = actividadcliente.slice(0, -1).join(', ') + ' y ' + actividadcliente.slice(-1);
        }

        return combinacionCadena;
    }

    const obtenerDomicilios = (domiciliosCliente) => {
        let domicilios = []
        let cadenaDomicilios = '';

        domiciliosCliente?.map(domicilio => {
            domicilios.push(
                "Calle " + domicilio.calle + " núm. exterior " + domicilio.numeroexterior + " núm. interior " + domicilio.numerointerior +
                ", Colonia " + domicilio.colonia + ", Localidad " + domicilio.localidad + ", Municipio " + domicilio.municipioalcaldia +
                ", Estado de " + domicilio.estado + ", C.P. " + domicilio.codigopostal + ". "
            )
        })

        if (domicilios.length == 1) {
            cadenaDomicilios = domicilios[0];
        } else if (domicilios.length > 1) {
            cadenaDomicilios = domicilios.join("\n");
        }

        return cadenaDomicilios;
    }


    return (
        <Fragment>
            <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button className="btn btn-outline-success"
                    onClick={() => filtrarClientesExcel()} >
                    <DownloadIcon /> Descargar reporte de Excel
                </button>
            </div>
        </Fragment>
    )
}

export default withRouter(BotonReporteExcelComponent)